import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Chips } from '@naf/chips';
import { spacing } from '@naf/theme';
import { findTopCategorySlug } from '../../../utils/createCategoryUrl';
import { Category } from '../../../../../types/articleType';

interface TagsListProps {
  tags: { name: string; slug: string }[];
  mappedCategories: { [key: string]: any };
  category: Category | null;
  articleUrl: string;
}

const ArticleTags: React.FC<TagsListProps> = ({ tags, mappedCategories, category, articleUrl }) => {
  const history = useHistory();

  const handleTagClick = (chipUrl: string) => {
    history.push(chipUrl);
  };

  return (
    <TagsWrapper>
      {tags.map((tag) => {
        const chipCategory = mappedCategories[tag.slug]?.data;
        let chipUrl = chipCategory?.url || articleUrl;

        if (chipCategory?.isGlobalTag && category) {
          const topCategorySlug = findTopCategorySlug(category);
          if (topCategorySlug) chipUrl = `/${topCategorySlug}/${chipCategory.slug}`;
        }

        return (
          <Chips
            className="tags-chip"
            key={`chip-${tag.name}`}
            text={tag.name}
            onClick={() => handleTagClick(chipUrl)}
          />
        );
      })}
    </TagsWrapper>
  );
};

const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.space8};
`;

export default ArticleTags;
